import { BindingCreator, createTranslatedText } from '@dreryk/react-common';
import { Multiselect } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

import { PatientGroup } from './PatientGroupField.types';
import {
   usePatientGroupFilterSearchParamHandler,
   usePatientGroupTriggerLabelExtractor,
} from './PatientGroupField.hooks';
import { StyledPatientGroupField } from './PatientGroupField.styled';

type PatientGroupFieldFormBeanPart = { patientGroups: PatientGroup[] };

type PatientGroupFieldProps = {
   register: BindingCreator<PatientGroupFieldFormBeanPart, 'patientGroups'>;
   currentFilter: PatientGroup[];
   patientGroups: PatientGroup[];
};

export const PatientGroupField = (props: PatientGroupFieldProps): JSX.Element => {
   return (
      <StyledPatientGroupField>
         <Multiselect<PatientGroup>
            testId={'patientGroups'}
            triggerLabelExtractor={usePatientGroupTriggerLabelExtractor(props.patientGroups)}
            placeholder={appointmentsTranslationKeys.patientGroupFilter.selectPatientGroups}
            controller={props.register('patientGroups')}
            onHide={usePatientGroupFilterSearchParamHandler(props.currentFilter)}
         >
            <>
               <Multiselect.SelectAll<PatientGroup>
                  testId={'selectAllPatientGroups'}
                  items={props.patientGroups}
                  selectAllLabel={appointmentsTranslationKeys.patientGroupFilter.selectAll}
               />
               <Multiselect.List items={props.patientGroups} keyExtractor={'id'}>
                  {(item) => <Multiselect.Item item={item} testId={item.id} label={createTranslatedText(item.name)} />}
               </Multiselect.List>
            </>
         </Multiselect>
      </StyledPatientGroupField>
   );
};
